import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Play } from '../../res/play.svg';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupTemplate03 from '../../popups/PopupTemplate03';
import PopupInterview from '../../popups/PopupInterview';
import Card from '../../components/Card';

import styles from './styles';

class B04fede extends React.Component {
  renderContent() {
    const { classes, blockData, baseUrl, onPopup } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.main}>
          <div className={`${classes.card1} ${classes.cardMobile}`}>
            <Card
              data={blockData}
              title={parse(blockData.card1.title)}
              textcolor="yellow"
              imgSrc={`${baseUrl}/blocks/${parse(blockData.card1.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup('popupFedeOPH', true)}>
                  {parse(blockData.card1.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="blue" icon={<Play />} onClick={() => onPopup('popupItvMarcelRogemont', true)}>
                  {parse(blockData.card1.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card2} ${classes.cardMobile}`}>
            <Card
              data={blockData}
              title={parse(blockData.card2.title)}
              textcolor="yellow"
              imgSrc={`${baseUrl}/blocks/${parse(blockData.card2.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup('popupFedeESH', true)}>
                  {parse(blockData.card2.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="blue" icon={<Play />} onClick={() => onPopup('popupItvValerieFournier', true)}>
                  {parse(blockData.card2.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card3} ${classes.cardMobile}`}>
            <Card
              data={blockData}
              title={parse(blockData.card3.title)}
              textcolor="yellow"
              imgSrc={`${baseUrl}/blocks/${parse(blockData.card3.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup('popupFedeCoop', true)}>
                  {parse(blockData.card3.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon
                  color="blue"
                  icon={<Play />}
                  onClick={() => onPopup('popupItvMarieNoelleLienemann', true)}
                >
                  {parse(blockData.card3.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card4} ${classes.cardMobile}`}>
            <Card
              data={blockData}
              title={parse(blockData.card4.title)}
              textcolor="yellow"
              imgSrc={`${baseUrl}/blocks/${parse(blockData.card4.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup('popupFedeProcivis', true)}>
                  {parse(blockData.card4.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="blue" icon={<Play />} onClick={() => onPopup('popupItvYannickBorde', true)}>
                  {parse(blockData.card4.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
          <div className={`${classes.card5} ${classes.cardMobile}`}>
            <Card
              data={blockData}
              title={parse(blockData.card5.title)}
              textcolor="yellow"
              imgSrc={`${baseUrl}/blocks/${parse(blockData.card5.imgSrc)}`}
            >
              <div>
                <ButtonWithIcon color="blue" icon={<Add />} onClick={() => onPopup('popupFedeFNAR', true)}>
                  {parse(blockData.card5.evtBtn)}
                </ButtonWithIcon>
              </div>
              <div>
                <ButtonWithIcon color="blue" icon={<Play />} onClick={() => onPopup('popupItvDenisRambaud', true)}>
                  {parse(blockData.card5.itvBtn)}
                </ButtonWithIcon>
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      classes,
      blockData,
      baseUrl,
      popupsState,
      onPopup,
      popupFedeOPHData,
      popupFedeESHData,
      popupFedeCoopData,
      popupFedeFNARData,
      popupFedeProcivisData,
    } = this.props;
    const mainTitle = parse(blockData.mainTitle);
    const subtitle = parse(blockData.subtitle);
    const baseUrlBlock = `${baseUrl}/blocks/`;

    return (
      <div style={{ backgroundImage: `url(${baseUrlBlock}${blockData.bg})` }} className={classes.blockContainer}>
        <Typography variant="h1" className={classes.title}>
          {mainTitle}
        </Typography>
        <Typography variant="body1" color="secondary" className={classes.subtitle}>
          {subtitle}
        </Typography>
        {this.renderContent()}
        <PopupTemplate03
          popupData={popupFedeOPHData}
          open={!!popupsState.popupFedeOPH}
          baseUrl={baseUrl}
          color={popupFedeOPHData.color}
          onClose={() => onPopup('popupFedeOPH', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupFedeESHData}
          open={!!popupsState.popupFedeESH}
          baseUrl={baseUrl}
          color={popupFedeESHData.color}
          onClose={() => onPopup('popupFedeESH', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupFedeCoopData}
          open={!!popupsState.popupFedeCoop}
          baseUrl={baseUrl}
          color={popupFedeCoopData.color}
          onClose={() => onPopup('popupFedeCoop', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupFedeFNARData}
          open={!!popupsState.popupFedeFNAR}
          baseUrl={baseUrl}
          color={popupFedeFNARData.color}
          onClose={() => onPopup('popupFedeFNAR', false)}
        ></PopupTemplate03>
        <PopupTemplate03
          popupData={popupFedeProcivisData}
          open={!!popupsState.popupFedeProcivis}
          baseUrl={baseUrl}
          color={popupFedeProcivisData.color}
          onClose={() => onPopup('popupFedeProcivis', false)}
        ></PopupTemplate03>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupFedeOPHData}
          open={!!popupsState.popupItvMarcelRogemont}
          onClose={() => onPopup('popupItvMarcelRogemont', false)}
        ></PopupInterview>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupFedeESHData}
          open={!!popupsState.popupItvValerieFournier}
          onClose={() => onPopup('popupItvValerieFournier', false)}
        ></PopupInterview>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupFedeCoopData}
          open={!!popupsState.popupItvMarieNoelleLienemann}
          onClose={() => onPopup('popupItvMarieNoelleLienemann', false)}
        ></PopupInterview>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupFedeProcivisData}
          open={!!popupsState.popupItvYannickBorde}
          onClose={() => onPopup('popupItvYannickBorde', false)}
        ></PopupInterview>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupFedeFNARData}
          open={!!popupsState.popupItvDenisRambaud}
          onClose={() => onPopup('popupItvDenisRambaud', false)}
        ></PopupInterview>
      </div>
    );
  }
}

B04fede.propTypes = {
  classes: PropTypes.object.isRequired,
  blockData: PropTypes.object,
  baseUrl: PropTypes.string,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
  popupFedeOPHData: PropTypes.object,
  popupFedeESHData: PropTypes.object,
  popupFedeCoopData: PropTypes.object,
  popupFedeFNARData: PropTypes.object,
  popupFedeProcivisData: PropTypes.object,
};

export default withStyles(styles)(B04fede);
